// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1i7gg","inner":"Footer_inner__30SKF","nextIcon":"Footer_nextIcon__2tG-k","innerLeft":"Footer_innerLeft__19zx0"};